import React, { useState } from 'react';
import { useVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/volumeCapsule/state/config/configslice';
import { VolumeCapsuleConfigState } from 'widgets/liquiditySummary/volumeCapsule/state/config/VolumeCapsuleConfigState';
import { RadioGroup } from '@instinet-analytics/semantic-ui-components';
import './VolumeCapsuleSettings.scss';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const VolumeCapsuleSettingsText = `Volume Capsule Settings`;
export const VolumeCapsuleSettingsClassName = 'VolumeCapsuleSettingsModal';

export interface VolumeCapsuleSettingsProps {
    config?: VolumeCapsuleConfigState;
    onChange?: (nextDelta: Partial<VolumeCapsuleConfigState>) => void;
}
export default function VolumeCapsuleSettings(
    props: VolumeCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;

    const { config: configSliceConfig, dispatchConfigChanged } =
        useVolumeCapsuleConfigSlice();

    const config = propsConfig ?? configSliceConfig;

    const { showQuantitiesOnScale } = config;

    const {
        debouncedApplyWidgetConfigChange,
        immediateApplyWidgetConfigChange,
    } = useWidgetConfigUpdater(dispatchConfigChanged, onChange);

    const [showQuantitiesOnScaleKey, setShowQuantitiesOnScaleKey] = useState(
        showQuantitiesOnScale ? 'quantities' : 'percent'
    );

    const onShowQuantitiesOnScaleChange = (selectedKey: string) => {
        const nextShowQuantitiesOnScale = selectedKey === 'quantities';
        setShowQuantitiesOnScaleKey(selectedKey);
        immediateApplyWidgetConfigChange({
            showQuantitiesOnScale: nextShowQuantitiesOnScale,
        });
    };

    return (
        <div className="VolumeCapsuleSettings">
            <CapsuleSettingsSymbolEditor
                config={config}
                onChange={debouncedApplyWidgetConfigChange}
                group={true}
            />
            <div className="group">
                <div>X Axis Labels</div>
                <RadioGroup
                    className="x-axis-labels-radios"
                    selected={showQuantitiesOnScaleKey}
                    onChange={onShowQuantitiesOnScaleChange}
                    options={[
                        {
                            key: 'percent',
                            label: 'Percentages',
                        },
                        {
                            key: 'quantities',
                            label: 'Quantities',
                        },
                    ]}
                />
            </div>
            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
